module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/3@2x_1b0b419b5e2fac0d1a8afeca5cf243f6.png";